/**
 * TransactionType API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { checkTransactionType } from "../generated/transaction-type/transaction-type";

import { wrapMethod } from "./utils";

export const transactionType = {
  /** @see checkTransactionType */
  checkTransactionType: wrapMethod(checkTransactionType),
} as const;

export type TransactionTypeApi = typeof transactionType;
